import Phaser from 'phaser';
import { GAME_HEIGHT, GAME_WIDTH } from '../grid';

/**
 * Bottom-of-screen clipboard with step instructions.
 * Title + body can be updated via setText() as the level changes.
 */
export class Clipboard {
  private titleText: Phaser.GameObjects.Text;
  private bodyText: Phaser.GameObjects.Text;
  private readonly w = 420;
  private readonly h = 110;

  constructor(scene: Phaser.Scene, initialTitle: string, initialBody: string) {
    const x = GAME_WIDTH / 2 - this.w / 2;
    const y = GAME_HEIGHT - this.h - 18;

    const g = scene.add.graphics();
    // Shadow
    g.fillStyle(0x000000, 0.4);
    g.fillRoundedRect(x + 4, y + 6, this.w, this.h, 6);
    // Paper
    g.fillStyle(0xfaf6e8, 1);
    g.fillRoundedRect(x, y, this.w, this.h, 6);
    g.lineStyle(2, 0xb27a3a, 1);
    g.strokeRoundedRect(x, y, this.w, this.h, 6);
    // Clip at top
    g.fillStyle(0x9a9a9a, 1);
    g.fillRoundedRect(x + this.w / 2 - 28, y - 10, 56, 18, 4);
    g.fillStyle(0x3a3a3a, 1);
    g.fillCircle(x + this.w / 2, y - 1, 3);

    this.titleText = scene.add
      .text(x + this.w / 2, y + 22, initialTitle, {
        fontFamily: 'Arial Black, Impact, sans-serif',
        fontSize: '22px',
        color: '#222222',
      })
      .setOrigin(0.5, 0.5);

    this.bodyText = scene.add
      .text(x + this.w / 2, y + 70, initialBody, {
        fontFamily: 'Arial, sans-serif',
        fontSize: '16px',
        color: '#222222',
        align: 'center',
        wordWrap: { width: this.w - 30 },
      })
      .setOrigin(0.5, 0.5);
  }

  setText(title: string, body: string): void {
    this.titleText.setText(title);
    this.bodyText.setText(body);
  }
}
